export default __webpack_public_path__ + "static/media/brain.d13046cf.svg";